export default {
    template: document.querySelector('[data-quiz-ending-template]') ?
        document.querySelector('[data-quiz-ending-template]').innerHTML:
        null,
    props: {
        video: {
            type: String,
            required: true
        },
        referralhref: {
            type: String,
            required: false
        },
        referrallabel: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            // showVideoPlayer: true,
            showPlayAgainButton: true
        };
    },
    methods: {
        createYouTubeEmbed() {
            // create a youtube player
            this.videoPlayer = new YT.Player(this.$refs.videoPlayer, {
                height: '360',
                width: '640',
                videoId: this.video,
                playerVars: {
                    // controls: 0,
                },
                events: {
                    'onReady': this.playVideo,
                    'onStateChange': this.onPlayerStateChange
                }
            });
        },

        playVideo() {
            this.videoPlayer.playVideo();
        },

        onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.ENDED) {
                // this.showVideoPlayer = false;
                this.showPlayAgainButton = true;
                this.videoPlayer.destroy();
            }
        },

        playAgain() {
            window.location.reload();
        }
    },
    mounted() {
        // this.createYouTubeEmbed();
    }
}